

export interface ExchangeCurrency {
    CurrencyCode: string
    CurrencyName: string
    Buy: number
    Transfer: number
    Sell: number
}

export const DEFAULT_EXCHANGE_CURRENCY: ExchangeCurrency = {
    CurrencyCode: '',
    CurrencyName: '',
    Buy: 0,
    Transfer: 0,
    Sell: 0,
}